export default __webpack_public_path__ + "static/media/pgmico(6).8467add7.png";